/**
 * ArchiveDossierGrid — the main filtered results grid on /archive. Uses
 * the homepage DossierCard so every card inherits the design lock.
 *
 * Handles: loading skeleton, empty state, active-filter summary chip row.
 */
import React from "react";
import DossierCard from "../home/DossierCard";
import { XCircle } from "lucide-react";

const SKELETON_COUNT = 9;

const Skeleton = () => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-testid="archive-grid-skeleton">
    {Array.from({ length: SKELETON_COUNT }).map((_, i) => (
      <div
        key={`skeleton-${i}`}
        className="border h-[380px] animate-pulse relative overflow-hidden"
        style={{ borderColor: "#2D2A26", background: "#0F0E12" }}
      >
        <div className="absolute top-4 left-4 h-3 w-16 bg-[#2D2A26]" />
        <div className="absolute top-4 right-4 h-3 w-12 bg-[#2D2A26]" />
        <div className="absolute bottom-6 left-4 right-4 space-y-3">
          <div className="h-5 w-4/5 bg-[#2D2A26]" />
          <div className="h-3 w-3/5 bg-[#2D2A26]" />
          <div className="h-3 w-2/5 bg-[#2D2A26]" />
        </div>
      </div>
    ))}
  </div>
);

const EmptyState = ({ onClear }) => (
  <div
    data-testid="archive-empty"
    className="border-2 border-dashed p-12 md:p-16 text-center"
    style={{ borderColor: "#2D2A26", background: "#0B0A0D" }}
  >
    <XCircle size={28} className="text-[#D92D20] mx-auto mb-4" />
    <div className="font-display text-2xl md:text-3xl text-[#E4DFD3] mb-2">No matching files</div>
    <div className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#7B7168] mb-6">
      // ARCHIVE RETURNED ZERO CLASSIFIED HITS
    </div>
    {onClear ? (
      <button
        onClick={onClear}
        data-testid="archive-empty-clear"
        className="inline-flex items-center gap-2 px-5 py-2.5 font-mono text-[10px] uppercase tracking-[0.35em]
                   border border-[#D92D20] text-[#E4DFD3] hover:bg-[#D92D20] transition-colors"
      >
        Reset filters
      </button>
    ) : null}
  </div>
);

const Grid = ({ topics }) => (
  <div
    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6"
    data-testid="archive-grid"
  >
    {topics.map((t) => (
      <DossierCard key={t.id || t.slug} dossier={t} />
    ))}
  </div>
);

export const ArchiveDossierGrid = ({ topics, loading, onClear }) => {
  if (loading) return <Skeleton />;
  if (!topics || topics.length === 0) return <EmptyState onClear={onClear} />;
  return <Grid topics={topics} />;
};

export default ArchiveDossierGrid;
